var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-overlay',{attrs:{"show":_vm.isShow,"custom-style":{
      background: 'rgb(255, 255, 255, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      paddingTop: '100px'
    }}},[_c('van-loading',{attrs:{"size":"24px","color":"#4994df"}},[_c('span',{staticStyle:{"color":"#4994df"}},[_vm._v(_vm._s(_vm.title || '加载中···'))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c84130f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
// module id = null
// module chunks = 